import React from 'react';

const PieChartSearchIcon: React.FC = () => (
  <svg width="74" height="75" viewBox="0 0 74 75" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M64.7906 65.0162L58.141 58.3665L51.4913 51.7169M58.9435 57.564L65.5932 64.2137L63.9881 65.8188L57.3384 59.1691M58.676 34.443C58.676 47.9511 47.7255 58.9016 34.2174 58.9016C20.7093 58.9016 9.75879 47.9511 9.75879 34.443C9.75879 20.9349 20.7093 9.98438 34.2174 9.98438C47.7255 9.98438 58.676 20.9349 58.676 34.443Z"
      stroke="#475467"
      strokeWidth="4.58599"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.3042 21.0072C38.0774 20.6351 36.9632 21.5052 36.7631 22.6213L35.4699 29.8358C35.21 31.2855 36.4747 32.5502 37.9244 32.2903L45.1389 30.9971C46.255 30.797 47.1251 29.6828 46.753 28.456C45.6728 24.8948 42.8654 22.0874 39.3042 21.0072Z"
      fill="#00A389"
    />
    <g opacity="0.4">
      <path
        d="M34.8068 23.2664C34.8315 23.1285 34.7341 22.9983 34.5945 22.9865C34.2798 22.9599 33.9613 22.9463 33.6397 22.9463C27.4668 22.9463 22.4626 27.9504 22.4626 34.1234C22.4626 40.2963 27.4668 45.3005 33.6397 45.3005C39.8127 45.3005 44.8168 40.2963 44.8168 34.1234C44.8168 33.8008 44.8031 33.4814 44.7764 33.1657C44.7645 33.0261 44.6343 32.9288 44.4964 32.9535L38.2449 34.0741C35.5526 34.5567 33.2039 32.2081 33.6865 29.5158L34.8068 23.2664Z"
        fill="#00A389"
      />
      <path
        d="M36.6329 23.3516C40.3989 24.3958 43.3657 27.3619 44.4108 31.1275L37.9251 32.2901C36.4754 32.5499 35.2107 31.2853 35.4706 29.8356L36.6329 23.3516Z"
        fill="#00A389"
      />
    </g>
  </svg>
);

export default PieChartSearchIcon;
